import { formatCurrency } from "@/lib/utils";

import type { RawMaterial, UnitConversion } from "@artisancode/api-types";

/** A purchased item's unit is a sized package ("Pouch 500g"), so its name reads better than its symbol. */
export function rawMaterialUomLabel(
  rm: Pick<RawMaterial, "kind" | "uom">,
): string | undefined {
  return rm.kind === "purchased" ? rm.uom?.name : rm.uom?.symbol;
}

/** Cost is set by the system (opening stock, purchases, repacking); null until then. */
export function formatCostPerUnit(
  rm: Pick<RawMaterial, "costPerUnit" | "kind" | "uom">,
): string {
  if (rm.costPerUnit == null) return "Belum ada harga";
  return `${formatCurrency(rm.costPerUnit)} / ${rawMaterialUomLabel(rm) ?? "satuan"}`;
}

/** Ingredient quantity one package holds: the conversion between the two units, either direction. */
export function packSize(
  conversions: UnitConversion[],
  packUomId: string,
  ingredientUomId: string,
): number | null {
  const direct = conversions.find(
    (c) => c.fromUnitId === packUomId && c.toUnitId === ingredientUomId,
  );
  if (direct) return direct.factor;
  const reverse = conversions.find(
    (c) => c.fromUnitId === ingredientUomId && c.toUnitId === packUomId,
  );
  return reverse ? 1 / reverse.factor : null;
}
